export function createSpinner({ Root, }) {
    Root.displayName = 'Spinner';
    Root.defaultProps = {
        // @ts-ignore
        'tabIndex': 0,
        'aria-label': 'loading',
    };
    return Root;
}
